import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=e6c14b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6c14b44"]])

export default __exports__